import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import useStore from '../store';

const schema = yup.object().shape({
  name: yup.string().required('Введите название бани'),
  date: yup.string().required('Выберите дату посещения'),
  startTime: yup.string().required('Укажите время начала'),
  endTime: yup.string().required('Укажите время окончания'),
  hourlyRate: yup.number().typeError('Укажите число').positive('Стоимость должна быть положительной').required('Укажите стоимость часа'),
  broomCost: yup.number().typeError('Укажите число').min(0, 'Стоимость не может быть отрицательной').required('Укажите стоимость веника'),
});

export default function SetupScreen({ onSave, initialData }) {
  const updateBanyaSettings = useStore((s) => s.updateBanyaSettings);
  const banya = useStore((s) => s.banya);

  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('19:00');
  const [endTime, setEndTime] = useState('00:00');
  const [hourlyRate, setHourlyRate] = useState('1170');
  const [broomCost, setBroomCost] = useState('300');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setName(initialData.name || '');
      setDate(initialData.date || '');
      setStartTime(initialData.startTime || '19:00');
      setEndTime(initialData.endTime || '00:00');
      setHourlyRate(String(initialData.hourlyRate ?? 1170));
      setBroomCost(String(initialData.broomCost ?? 300));
    } else if (banya) {
      setName(banya.name || '');
      setDate(banya.date || '');
      setStartTime(banya.startTime || '19:00');
      setEndTime(banya.endTime || '00:00');
      setHourlyRate(String(banya.hourlyRate ?? 1170));
      setBroomCost(String(banya.broomCost ?? 300));
    } else {
      // Новая баня — дефолтные значения
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const yyyy = today.getFullYear();
      setName(`Баня ${dd}.${mm}.${yyyy} г.`);
      // local date YYYY-MM-DD
      const localDate = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().split('T')[0];
      setDate(localDate);
    }
  }, [initialData, banya]);

  const handleSave = async () => {
    try {
      await schema.validate(
        { name, date, startTime, endTime, hourlyRate: Number(hourlyRate), broomCost: Number(broomCost) },
        { abortEarly: false }
      );
      setErrors({});
      if (banya) {
        updateBanyaSettings({
          name,
          date,
          startTime,
          endTime,
          hourlyRate: Number(hourlyRate),
          broomCost: Number(broomCost),
        });
      }
      onSave && onSave(startTime, endTime, Number(hourlyRate), Number(broomCost), name, date);
    } catch (err) {
      const fieldErrors = {};
      err.inner.forEach((e) => {
        fieldErrors[e.path] = e.message;
      });
      setErrors(fieldErrors);
    }
  };

  return (
    <div className="setup-screen">
      <div className="form-group">
        <label>Название бани</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Например: Баня «Толстяк»" />
        {errors.name && <span className="field-error">{errors.name}</span>}
      </div>

      <div className="form-group">
        <label>Дата посещения</label>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        {errors.date && <span className="field-error">{errors.date}</span>}
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Начало</label>
          <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
          {errors.startTime && <span className="field-error">{errors.startTime}</span>}
        </div>
        <div className="form-group">
          <label>Конец</label>
          <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
          {errors.endTime && <span className="field-error">{errors.endTime}</span>}
        </div>
      </div>

      <div className="form-group">
        <label>Стоимость часа (₽)</label>
        <input type="number" value={hourlyRate} onChange={(e) => setHourlyRate(e.target.value)} min="0" />
        {errors.hourlyRate && <span className="field-error">{errors.hourlyRate}</span>}
      </div>

      <div className="form-group">
        <label>Стоимость веника (₽)</label>
        <input type="number" value={broomCost} onChange={(e) => setBroomCost(e.target.value)} min="0" />
        {errors.broomCost && <span className="field-error">{errors.broomCost}</span>}
      </div>

      <button className="btn-primary mt-8" onClick={handleSave} >
        {banya ? 'Сохранить изменения' : 'Сохранить'}
      </button>
    </div>
  );
}
